import { useEffect, useState } from 'react'
import { Spinner } from 'react-bootstrap'
import { KonektoNavbar } from '../../components'
import './Login.scss'
import Footer from '../../components/footer/Footer'
import { useDispatch, useSelector } from 'react-redux'
import { validateEmail } from '../../helpers'
import { authService } from '../../services/authService'
import { loginSuccess } from '../../store/Actions/Authentication'
import { useNavigate } from 'react-router-dom'
import config from '../../config/env'

export default function Login() {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const { token } = useSelector(state => state.authentication)

  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [emailError, setEmailError] = useState(null)
  const [passwordError, setPasswordError] = useState(null)

  const [loginError, setLoginError] = useState(null)
  const [loginLoader, setLoginLoader] = useState(false)

  useEffect(() => {
    if (config.DEBUG) {
      setEmail('dervicarmin15+new@gmail.com')
      setPassword('Makarska.2024')
    }
  }, [])

  const onLogin = async e => {
    setLoginError(null)
    e.preventDefault()

    const isEmailValid = validateEmail(email)
    if (!isEmailValid) {
      setEmailError('Email nije validan')
      return
    }

    if (password?.trim() === '') {
      setPasswordError('Lozinka nije validna')
      return
    }

    setLoginLoader(true)

    const loginResponse = await authService.login({ email, password })
    if (loginResponse.isOk && loginResponse.data) {
      dispatch(loginSuccess(loginResponse.data.token))
      navigate('/')
    } else {
      setLoginError(loginResponse.message)
    }

    setLoginLoader(false)
  }

  useEffect(() => {
    if (token) {
      navigate('/')
    }
  }, [token, navigate])

  return (
    <div className="login">
      <KonektoNavbar />

      <div className="container d-flex justify-content-center my-5">
        <div className="card p-4 shadow" style={{ width: '380px' }}>
          <h4 className="text-center mb-4">Prijava</h4>
          <form onSubmit={onLogin}>
            <div className="form-group mb-3">
              <label htmlFor="email" className="form-label">
                Email
              </label>
              <input
                type="email"
                className="form-control rounded-pill"
                id="email"
                placeholder="Unesite email"
                value={email || ''}
                onChange={e => {
                  setEmail(e.target.value)
                  if (emailError) {
                    setEmailError(null)
                  }
                }}
              />
              {emailError ? (
                <span className="field-error">{emailError}</span>
              ) : null}
            </div>
            <div className="form-group">
              <label htmlFor="password" className="form-label">
                Lozinka
              </label>
              <input
                type="password"
                className="form-control rounded-pill"
                id="password"
                placeholder="Unesite šifru"
                value={password || ''}
                onChange={e => {
                  setPassword(e.target.value)
                  if (passwordError) {
                    setPasswordError(null)
                  }
                }}
              />
              {passwordError ? (
                <span className="field-error">{passwordError}</span>
              ) : null}
            </div>
            <button
              type="submit"
              disabled={loginLoader}
              className="btn btn-primary btn-block w-100 mt-3 rounded-pill">
              {loginLoader ? (
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              ) : (
                'Prijavi se'
              )}
            </button>

            {loginError ? (
              <p className="field-error text-center mb-0 mt-2">{loginError}</p>
            ) : null}

            <div className="forgot-password-wrapper">
              <a
                className="pointer"
                onClick={() =>
                  navigate('/zaboravljena-lozinka')
                }>{`Zaboravili ste lozinku?`}</a>
            </div>
          </form>

          <hr />

          <div className="row align-items-center mt-2">
            <div className="col">
              <span>Nemate korisnički račun?</span>
            </div>

            <div className="col-auto">
              <button
                type="button"
                className="btn btn-outline-primary registration-button rounded-pill px-3"
                onClick={() => {
                  navigate('/registracija')
                }}>
                Registruj se
              </button>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  )
}
